import {StateUtils} from "@spartacus/core";
import {MULTI_CART_DATA} from "@spartacus/cart/base/core";

export const GONVARRI_UPDATE_CART = '[Update Saved Cart] Gonvarri Save Cart';

export class GonvarriUpdateCart extends StateUtils.EntityLoadAction {
  override readonly type = GONVARRI_UPDATE_CART;
  constructor(
    public payload: {
      userId: string;
      cartId: string;
      saveCartName?: string;
      saveCartDescription?: string;
      cloneCart?: boolean;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}
